import CONSTANTS from "utils/constants";

const { LOCAL_STORAGE: { ACCESS_TOKEN, REFRESH_TOKEN } } = CONSTANTS;

export function getToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN)
}

export const TOKEN_UPDATED_EVENT = 'toqio:token-updated';

export function setToken(accessToken: string): void {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
  // Notify in-tab listeners (the native `storage` event only fires in OTHER
  // tabs). FormHost listens for this to forward token refreshes to the iframe.
  window.dispatchEvent(new Event(TOKEN_UPDATED_EVENT));
}

export function removeToken(): void {
  localStorage.removeItem(ACCESS_TOKEN);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN);
}

export function setRefreshToken(accessToken: string): void {
  localStorage.setItem(REFRESH_TOKEN, accessToken);
}

export function removeRefreshToken(): void {
  localStorage.removeItem(REFRESH_TOKEN);
}